import React from 'react';
import TileButton from './TileButton';
import {IconButton, Tooltip, Typography} from '@mui/material';
import SourceIcon from '@mui/icons-material/Source';
import {useTranslation} from 'react-i18next';
import {useTheme} from '@mui/material/styles';

interface FileFromSourceButtonProps {
    onClick: () => void;
    disable?: boolean;
}

const FileFromSourceButton: React.FC<FileFromSourceButtonProps> = ({onClick, disable}) => {
    const {t} = useTranslation();
    const theme = useTheme();

    return (
        <TileButton onClick={onClick}>
            <Tooltip title={t('attachFiles.selectFileFromSource')}>
                <label>
                    <Typography color="primary" variant="button">
                        {t('attachFiles.fromApp')}
                    </Typography>
                    <IconButton component="span"
                                sx={{
                                    '&:hover': {
                                        backgroundColor: 'transparent'
                                    },
                                    color: theme.palette.primary.main,
                                }}>
                        <SourceIcon/>
                    </IconButton>
                </label>
            </Tooltip>
        </TileButton>
    );
};

export default FileFromSourceButton;